import OpacityTransition from 'components/reusable/OpacityTransition'

// This page displays when "Change plans" is clicked from the member homepage in order to validate the QLE date and
// create the QLE enrollment event.
// Once the enrollment event is created, the user is redirected to the renewals flow instead of this page.
export const QleStartPage = () => {
  // TODO(@ashley): Use create on Next button clicked to validate QLE info / create the enrollment event
  // memberOnboardingQleStart.create()

  return (
    <OpacityTransition>
      v2 QLE Start Page
    </OpacityTransition>
  )
}

export default QleStartPage
